import { Grid2, Stack } from '@mui/material'
import React, { isValidElement } from 'react'
import PropTypes from 'prop-types'
import { map, isObject } from 'lodash'

const PopoverContent = ({ explaination, legend }) => {
    return (
        <Grid2 container size={12} spacing={1.5} paddingBottom={1.5}>
            {!!explaination && <Grid2>{explaination}</Grid2>}
            <Stack spacing={1}>
                {map(legend?.keys, (value, key) => (
                    <Grid2 container key={key} spacing={0.5}>
                        {
                            isObject(value) && !isValidElement(value) ?
                                <Grid2 sx={{ fontWeight: 'bold', color: value.color }}>{value.label}</Grid2>
                                :
                                <Grid2 sx={{ fontWeight: 'bold' }}>{value}</Grid2>
                        }
                        <Grid2 size={12}>{legend?.label?.[key]}</Grid2>
                    </Grid2>
                ))}
            </Stack>
        </Grid2>
    )
}

PopoverContent.propTypes = {
    explaination: PropTypes.string,
    legend: PropTypes.shape({
        keys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.shape({})])),
        label: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element])),
    }),
}

export default PopoverContent